export default class Tailgating {
  constructor() {
    this.state = {
      scrollOffset: $('#content-nav').height() + 5,
      contentNav: $('#content-nav > div'),
      activeUnderline: $('#content-nav .active-link-underline'),
      currentItem: $('#content-nav .active') ? $('#content-nav .active').parent() : $('#content-nav li:eq(0)'),
    };

    this.initListeners();
  }

  initListeners() {
    console.info('Tailgating.initListeners()');

    const playVideo = (e) => {
      e.preventDefault();

      const youtubeID = $(e.currentTarget).data('video');
      const sectionID = $(e.currentTarget).data('id');
      $('#video-thumbnail--' + sectionID).hide();

      this.onYouTubeIframeAPIReady(youtubeID, sectionID);
    };

    $('.js-play-video').on('click', playVideo);

    $('.js-play-video').on('keydown', (e) => {
      if (e.keyCode == 13 || e.keyCode == 32) {
        playVideo(e);
      }
    });

    console.info('this.state: ', this.state);

    this.contentNav();
    this.stickyElements();
    this.viewMoreRecipes();
    this.storySlider();
  }

  stickyElements() {
    /*****************************************
     * Sticky elements
     *****************************************/
    $(document).ready(() => {
      $('.sticky-wrapper').each((index, element) => {
        const stickyHeader = $(element)[0];

        if (stickyHeader) {
          console.log('init sticky nav');
          this.initStickyNav(stickyHeader);
        }
      });
      setTimeout(this.renderMenuUnderline(), 1000);
    });
  }

  initStickyNav(stickyHeader) {
    const stickyOffset = $('.global-header')[0].offsetHeight + $('.page-hero__wrapper')[0].offsetHeight;

    this.stickyClass(stickyHeader, stickyOffset); // Position sticky nav on page load

    window.addEventListener('scroll', () => {
      this.stickyClass(stickyHeader, stickyOffset);
    });
  }

  // Add or remove the sticky class based on window scroll position.
  stickyClass(el, y) {
    // if (window.pageYOffset > 20) {
    if (window.pageYOffset > y) {
      el.classList.add('stuck');
    } else {
      el.classList.remove('stuck');
    }
  }

  contentNav() {
    /***************************
     * Content Nav
     ***************************/
    $.fn.isInViewportV = function () {
      var elementLeft = $(this).offset().left;
      var elementRight = elementLeft + $(this).outerWidth();
      var viewportRight = $(window).width();
      return elementLeft > 0 && elementRight < viewportRight;
    };

    $(window).on('resize', () => {
      this.renderMenuUnderline();
    });

    $(window).on('activate.bs.scrollspy', (e, obj) => {
      this.state.currentItem = $('#content-nav .active').parent();

      if (!this.state.currentItem.isInViewportV()) {
        var width = this.state.currentItem.outerWidth();
        if (this.state.currentItem.offset().left + width > $(window).width()) {
          this.slideLeft();
        } else {
          this.slideRight();
        }
      } else {
        this.renderMenuUnderline();
      }
    });

    $('body').scrollspy({ target: '#content-nav', offset: 80 });

    $('#content-nav a').on('click', (e) => {
      if (e.currentTarget.hash !== '') {
        e.preventDefault();
        let hash = e.currentTarget.hash;

        if (!$('#content-nav').hasClass('stuck') && hash !== '#section--pellet-grilling') {
          this.state.scrollOffset = $('#content-nav').height() * 2;
        } else if ($('#content-nav').hasClass('stuck') && hash === '#section--pellet-grilling') {
          this.state.scrollOffset = 0;
        } else {
          this.state.scrollOffset = $('#content-nav').height();
        }

        let offset = $(hash).offset().top - this.state.scrollOffset;

        console.info('offset: ', offset);

        $('html, body').animate(
          {
            scrollTop: offset,
          },
          500
        );
      }
    });
  }

  renderMenuUnderline() {
    const el = this.state.currentItem ? this.state.currentItem : $('#content-nav li:eq(0)');
    if (el[0]) {
      this.state.activeUnderline.css({
        width: el.width(),
        left: el.offset().left - el.offsetParent().offset().left,
      });
    }
  }

  slideLeft() {
    if (!this.state.contentNav.isInViewportV() && this.state.contentNav.offset().left == 0) {
      const offset = this.state.contentNav[0].scrollWidth - $(window).width() + 130;
      this.state.contentNav.animate(
        {
          'margin-left': '-=' + offset,
        },
        200,
        'swing',
        () => {
          this.renderMenuUnderline();
        }
      );
    }
  }

  slideRight() {
    if (!this.state.contentNav.isInViewportV() && this.state.contentNav.offset().left != 0) {
      this.state.contentNav.animate(
        {
          'margin-left': 0,
        },
        200,
        'swing',
        () => {
          this.renderMenuUnderline();
        }
      );
    }
  }

  viewMoreRecipes() {
    console.info('Tailgating.viewMoreRecipes()');

    $('.js-recipe-grid').on('shown.bs.collapse', function () {
      $(this).siblings('.js-see-more-toggle').html('View Fewer Recipes <span>&#10217;</span>');
      $(this).siblings('.js-see-more-toggle').addClass('collapsed');
    });

    $('.js-recipe-grid').on('hidden.bs.collapse', function () {
      $(this).siblings('.js-see-more-toggle').html('View More Recipes <span>&#10217;</span>');
      $(this).siblings('.js-see-more-toggle').removeClass('collapsed');
    });
  }

  onYouTubeIframeAPIReady(youtubeID, sectionID) {
    let player = new YT.Player('video-player--' + sectionID, {
      height: '390',
      width: '640',
      videoId: youtubeID,
      events: {
        onReady: this.onPlayerReady,
      },
    });
  }

  onPlayerReady(event) {
    event.target.playVideo();
  }

  storySlider() {
    $('.slick-slideshow').slick({
      centerMode: true,
      infinite: true,
      slidesToShow: 1,
      dots: true,
      variableWidth: true,
      prevArrow:
        '<img src="/wp-content/themes/electro/img/tailgate/tailgating-slider-prev.png" class="slider-arrow slider-arrow-prev" alt="previous"/>',
      nextArrow:
        '<img src="/wp-content/themes/electro/img/tailgate/tailgating-slider-next.png" class="slider-arrow slider-arrow-next" alt="next"/>',
    });
  }
}
